<template>
  <the-content>
    <div class="heading">
      <div class="heading-nav">
        <v-btn :to="{name: 'card-types.list'}" text fab small exact>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
      <h1 class="heading-title">Редактирование вида абонемента</h1>
    </div>

    <ValidationObserver ref="form" v-slot="{ passes, dirty }">
      <v-form @submit.prevent="passes(onSubmit)">
        <v-card class="client-card" :class="{'view-xs': $vuetify.breakpoint.xsOnly}">
          <v-card-text class="px-6">

            <v-row>
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="name"
                  rules="required"
                  v-slot="{ errors }"
                  tag="div"
                  class="client-info-group">
                  <v-text-field
                    type="text"
                    v-model="name"
                    label="Название абонемента"
                    outlined
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="7" sm="8" class="pb-0">
                <ValidationProvider
                  name="duration"
                  rules="required"
                  v-slot="{ errors }"
                  tag="div"
                  class="client-info-group">
                  <v-text-field
                    type="number"
                    v-model="duration"
                    :label="durationLabel"
                    outlined
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>


              <v-col cols="5" sm="4" class="pb-0">
                <ValidationProvider
                  name="duration_unit"
                  rules="required"
                  v-slot="{ errors }"
                  tag="div"
                  class="client-info-group">
                  <v-select
                    v-model="duration_unit"
                    :items="[{title:'Месяц', value: 'month'}, {title:'День', value: 'day'}]"
                    item-text="title"
                    item-value="value"
                    outlined
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="visits_limit"
                  v-slot="{ errors }"
                  tag="div"
                  class="client-info-group">
                  <v-text-field
                    type="number"
                    v-model="visits_limit"
                    label="Количество посещений"
                    outlined
                    hint=" Оставить пустым если нет лимита"
                    persistent-hint
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>

        <div class="client-actions mt-8 text-center">
          <v-btn :to="{name: 'card-types.list'}" exact dark color="blue-grey" min-width="200" class="ma-2">
            Отмена
          </v-btn>
          <v-btn type="submit" color="success" min-width="200" class="ma-2" :disabled="!dirty">Сохранить
          </v-btn>
        </div>
      </v-form>
    </ValidationObserver>
  </the-content>
</template>

<script>
  import cardTypesApi from '../api/card-type.api';

  export default {
    name: "CardTypeEditPage",
    props: {
      cardTypeId: {
        required: true,
      }
    },
    data() {
      return {
        name: '',
        duration: '',
        duration_unit: '',
        visits_limit: '',
      }
    },
    computed: {
      durationLabel() {
        return 'Количество ' + (this.duration_unit === 'month' ? 'месяцев' : 'дней');
      }
    },
    created() {
      this.$store.commit('setLoading', true);

      cardTypesApi.find(this.cardTypeId).then(({data}) => {
        const cardType = data.data;
        this.name = cardType.name;
        this.duration = cardType.duration;
        this.duration_unit = cardType.duration_unit;
        this.visits_limit = cardType.visits_limit;
      }).catch(() => {
        this.$toast.error('Что-то пошло не так. Пожалуйста, повторите попытку позже');
      }).finally(() => {
        this.$store.commit('setLoading', false);
      });
    },
    methods: {
      onSubmit() {
        this.$store.commit('setLoading', true);

        cardTypesApi.update(this.cardTypeId, {
          name: this.name,
          duration: this.duration,
          duration_unit: this.duration_unit,
          visits_limit: this.visits_limit,
        }).then(({data}) => {
          const card = data.data;
          this.$store.commit('card-types/UPDATE_ITEM', {id: card.id, data: card});
          this.$router.push({name: 'card-types.list'});
        }).catch(({response}) => {
          this.$refs.form.setErrors(response.data.errors);
        }).finally(() => {
          this.$store.commit('setLoading', false);
        });
      }
    }
  }
</script>

<style scoped>

</style>
